import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api, { getErrorDetail } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function ForgotPasswordPage() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSubmitted(true);
    } catch (err) {
      toast.error(getErrorDetail(err));
    } finally { setLoading(false); }
  }

  return (
    <main data-testid="forgot-page" className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-8 md:p-16">
      <div className="w-full max-w-md space-y-6 bg-white p-8 rounded-2xl border border-[hsl(var(--border))]">
        <Link to="/login" className="inline-flex items-center gap-1 text-xs tracking-[0.25em] uppercase text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))]">
          <ArrowLeft className="w-3 h-3" />{t.forgot.back_to_login}
        </Link>

        {!submitted ? (
          <form onSubmit={submit} className="space-y-6" data-testid="forgot-form">
            <div>
              <h1 className="font-display text-3xl md:text-4xl tracking-tight font-medium">{t.forgot.title}</h1>
              <p className="text-sm text-[hsl(var(--muted-foreground))] mt-2">{t.forgot.sub}</p>
            </div>
            <div>
              <Label htmlFor="fp-email" className="text-xs uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))]">{t.auth.email}</Label>
              <Input id="fp-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="forgot-email" className="mt-2" />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-white rounded-full">
              {loading ? "…" : t.forgot.submit}
            </Button>
          </form>
        ) : (
          <div data-testid="forgot-success" className="space-y-4">
            <h1 className="font-display text-3xl tracking-tight font-medium">{t.forgot.sent_title}</h1>
            <p className="text-sm text-[hsl(var(--muted-foreground))]">{t.forgot.sent_body}</p>
            <Link to="/login" className="inline-block text-sm text-[hsl(var(--primary))] hover:underline">{t.forgot.back_to_login}</Link>
          </div>
        )}
      </div>
    </main>
  );
}
